export default {
    car_00001: "请输入团体名称",
    car_00002: "车辆",
    car_00003: "生成并绑定即插即充卡",
    car_00004: "添加车辆",
}